import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import ConditionLogicBox from '../common/ConditionLogicBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionsGroupConditionsCondition = ({
  usingWidePanel,
  hasLogicBox,
  logicGroupIndex,
  logicOperator,
  children,
  hideOperator,
  showOperatorToggle,
  showLogicGroupOperatorToggles
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: usingWidePanel ? 'row' : 'column',
    gap: "100",
    alignItems: usingWidePanel ? 'baseline' : 'stretch',
    children: [hasLogicBox && /*#__PURE__*/_jsx(Flex, {
      minInlineSize: "42px",
      justifyContent: usingWidePanel ? 'end' : 'start',
      children: hideOperator ? null : /*#__PURE__*/_jsx(ConditionLogicBox, {
        logicGroupIndex: logicGroupIndex,
        logicOperator: logicOperator,
        showToggle: showOperatorToggle,
        showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
      })
    }), /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      minInlineSize: "0",
      children: children
    })]
  });
};
export default ViewerConditionsGroupConditionsCondition;